var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconTextUnderline = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_48249_27939)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.83333 11.3333V12.6667H13.1667V11.3333H3.83333ZM6.83333 8.53333H10.1667L10.7667 10H12.1667L9 2.66667H8L4.83333 10H6.23333L6.83333 8.53333ZM8.5 3.98667L9.74667 7.33333H7.25333L8.5 3.98667Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_48249_27939"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.5)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconTextUnderline);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-text-underline.e4c8f1b40fdaf22d4b9845de8c334818.svg";